module.exports = __webpack_public_path__ + "img/dd-logo-nissan.d7f7a8b6.png";